import type { IAM as Interface } from "../../design/services";
import type { User, Authorization, Config } from "../../design/types";

export class IAM implements Interface {

    authz: Authorization[] = [];
    private onLoginCallback: (user: User) => void;
    private onLogoutCallback: () => void;
    currentUser: User | null = null;

    constructor(config: Config, onLogin: (user: User) => void, onLogout: () => void) {
        console.log(`IAM initialized with config: ${config.id}`);
        this.onLoginCallback = onLogin;
        this.onLogoutCallback = onLogout;
        this.authz = [];
    }

    ["constructor"](config: Config, onLogin: (user: User) => void, onLogout: () => void): Interface {
        return new IAM(config, onLogin, onLogout);
    }

    login(user: User): void {
        this.currentUser = user;
        this.onLoginCallback(user);
    }

    async logout(): Promise<void> {
        this.currentUser = null;
        this.onLogoutCallback();
    }

}